
    import Vue from 'vue';

    import { UserService }from '@/services/UserService'

    export default Vue.extend({
        data() {
            return {
                isValid: true,
                showDialog: false,
                dialogMessage: "",
                showErrors: false,
                hasPassword: false,
                errors: [""],
                loading: false,
                post: null,
                emailConfirmationToken: "",
                passwordResetToken: "",
                oldPassword: "",
                password: "",
                passwordRepeat: "",
                globalPassword: "",
                showPassword: false,
            }
        },
        async created() {
        },
        methods: {
            resetForm(): void {
                this.showDialog = false;
                this.oldPassword = "";
                this.password = "";
                this.passwordRepeat = "";

            },
            required(v: string): boolean | string {
                return !!v || this.$vuetify.lang.t('$vuetify.required')
            },
            matchingPasswords(v: string): boolean | string {
                if (v === this.globalPassword) {
                    return true;
                } else {
                    return this.$vuetify.lang.t('$vuetify.confirmUser.passwordDoesNotMatch');
                }
            },
            async submit() {
                this.$store.commit('addOverlay');
                UserService.ChangePassword({ oldPassword: this.oldPassword, password: this.password })
                    .then(() => {
                        this.dialogMessage = "";
                        this.dialogMessage += this.$vuetify.lang.t('$vuetify.user.passwordChanged') + " ";

                        this.showDialog = true;
                    }).catch((error) => {
                        if (error.response.data.errors) {
                            this.errors = error.response.data.errors;
                        } else {
                            this.errors = [this.$vuetify.lang.t('$vuetify.generalErrorMessage')];
                        }
                        this.showErrors = true;
                    }).finally(() => {
                        this.$store.commit('removeOverlay');
                    });
            }
        },
        watch: {
            password() {
                this.globalPassword = this.password;
                (this.$refs.form as Vue & { validate: () => boolean }).validate();
            },
        },
    });
